import type { Organization } from '#/domain/organization/Organization'
import type { OrganizationRepository } from '#/domain/organization/OrganizationRepository'

export class CreateOrganizationUseCase {
  constructor(private readonly repository: OrganizationRepository) {}

  async execute(organization: Organization): Promise<Organization> {
    return this.repository.create(organization)
  }
}
